(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0566/4250/2728/files/';
  var PX_PER_SECOND = 36;
  var START_DELAY = 1000;

  var POOLS = {
    pockets: [
      'AlyssaD-Pockets-HotPink_23.webp',
      'AlyssaD-Pockets-HotPink_24.webp',
      'AmandaC-Pockets-SafetyYellow_19.webp',
      'AmberH-Pockets-MidnightBlack_3.webp',
      'AmyM-Pockets-TangerineOrange_5.webp',
      'AnitaM-Pockets-SafetyYellow_20.webp',
      'BeccaD-Pockets-HotPink_5.webp',
      'BeccaD-Pockets-HotPink_8.webp',
      'BethG-Pockets-HotPink_25.webp',
      'BikerM-Pockets-SafetyYellow_21.webp',
      'BonnieD-Pockets-HotPink_17.webp',
      'CarrieOD-Pockets-PerfectPurple_7.webp',
      'CarrieR-Pockets-SafetyYellow_18.webp',
      'CX-Pockets-MidnightBlack_2.webp',
      'CX-Pockets-PerfectPurple_1.webp',
      'CX-Pockets-SafetyYellow_11.webp',
      'DanK-Pockets-HotPink_7.webp',
      'DesiraeF-Pockets-HotPink_9.webp',
      'DominiqueF-Pockets-HotPink_6.webp',
      'DominiqueF-Pockets-SafetyYellow_5.webp',
      'EricaM-Pockets-PerfectPurple_2.webp',
      'Findorff-Pockets-SafetyYellow_8.webp',
      'HeatherL-Pockets-SafetyYellow_16.webp',
      'HollyT-Pockets-SafetyYellow_9.webp',
      'JosieD-Pockets-TangerineOrange_1.webp',
      'KirstenB-Pockets-HotPink_2.webp',
      'LauraelM-Pockets-SafetyYellow_15.webp',
      'LauraH-Pockets-SafetyYellow_3.webp',
      'LauraP-Pockets-SafetyYellow_12.webp',
      'LesleyT-Pockets-HotPink_10.webp',
      'MargothS-Pockets-HotPink_16.webp',
      'MollyB-Pockets-SafetyYellow_6.webp',
      'MollyB-Pockets-SafetyYellow_10.webp',
      'NathanS-Pockets-SafetyYellow_7.webp',
      'NAWIC-Pockets-HotPink_15.webp',
      'NAWIC-Pockets-HotPink_24.webp',
      'NAWIC-Pockets-SafetyYellow_14.webp',
      'NAWIC-Pockets-SafetyYellow_16.webp',
      'NAWIC-Pockets-SafetyYellow_17.webp',
      'NAWIC-Pockets-TangerineOrange_2.webp',
      'NAWIC-Pockets-TangerineOrange_3.webp',
      'NAWIC-Pockets-TangerineOrange_4.webp',
      'NSC-Pockets-HotPink_19.webp',
      'NSC-Pockets-HotPink_20.webp',
      'Orlando-Pockets-PerfectPurple_5.webp',
      'PeggyDM-Pockets-PerfectPurple_3.webp',
      'PeggyDM-Pockets-PerfectPurple_4.webp',
      'SamanthaT-Pockets-HotPink_21.webp',
      'SarahC-Pockets-HotPink_3.webp',
      'SarahC-Pockets-SafetyYellow_1.webp',
      'SaraS-Pockets-PerfectPurple_6.webp',
      'SiliconValley-Pockets-HotPink_13.webp',
      'SilviaD-Pockets-HotPink_1.webp',
      'SolsticeH-Pockets-MidnightBlack_1.webp',
      'TaraR-Pockets-SafetyYellow_13.webp',
      'Wajidah-Pockets-HotPink_14.webp',
      'Zuri-Pockets-HotPink_25.webp'
    ],
    nopockets: [
      'AbigailA-NoPockets-HotPink_13.webp',
      'AmyG-NoPockets-TangerineOrange_2.webp',
      'AnnieD-NoPockets-HotPink_5.webp',
      'AnnieD-NoPockets-HotPink_12.webp',
      'BarbaraR-NoPockets-HotPink_14.webp',
      'BeccaD-NoPockets-SafetyYellow_13.webp',
      'CaseyR-NoPockets-MidnightBlack_2.webp',
      'CX-NoPockets-SafetyYellow_9.webp',
      'CX-NoPockets-SafetyYellow_17.webp',
      'CX-NoPockets-SafetyYellow_20.webp',
      'CX-NoPockets-SafetyYellow_25.webp',
      'CX-NoPockets-SafetyYellow_26.webp',
      'CX-NoPockets-SafetyYellow_27.webp',
      'CX-NoPockets-SafetyYellow_30.webp',
      'DominiqueF-NoPockets-TangerineOrange_6.webp',
      'Elizabeth-NoPockets-SafetyYellow_14.webp',
      'Elizabeth-NoPockets-SafetyYellow_15.webp',
      'Graves-NoPockets-SafetyYellow_28.webp',
      'JeanneteD-NoPockets-HotPink_1.webp',
      'JohnW-NoPockets-HotPink_8.webp',
      'KateB-NoPockets-SafetyYellow_16.webp',
      'KateM-NoPockets-HotPink_2.webp',
      'KateM-NoPockets-HotPink_3.webp',
      'KathrynF-NoPockets-SafetyYellow_19.webp',
      'LauraP-NoPockets-HotPink_4.webp',
      'LauraP-NoPockets-TangerineOrange_3.webp',
      'LauraP-NoPockets-TangerineOrange_4.webp',
      'LauraV-NoPockets-TangerineOrange_5.webp',
      'LaurenG-NoPockets-SafetyYellow_4.webp',
      'LaurenN-NoPockets-SafetyYellow_8.webp',
      'MargothS-NoPockets-RoyalBlue_1.webp',
      'MarissaR-NoPockets-SafetyYellow_6.webp',
      'MaryM-NoPockets-SafetyYellow_10.webp',
      'MaryR-NoPockets-SafetyYellow_2.webp',
      'MaxD-NoPockets-HotPink_11.webp',
      'MonicaA-NoPockets-SafetyYellow_12.webp',
      'MonicaA-NoPockets-SafetyYellow_18.webp',
      'NAWIC-NoPockets-SafetyYellow_3.webp',
      'NickyS-NoPockets-TangerineOrange_1.webp',
      'NooriH-NoPockets-HotPink_6.webp',
      'PaulaH-NoPockets-SafetyYellow_5.webp',
      'PaulaH-NoPockets-SafetyYellow_7.webp',
      'PoppyQ-NoPockets-SafetyYellow_21.webp',
      'PoppyQ-NoPockets-SafetyYellow_22.webp',
      'PoppyQ-NoPockets-SafetyYellow_23.webp',
      'PoppyQ-NoPockets-SafetyYellow_24.webp',
      'RebeccaF-NoPockets-MidnightBlack_1.webp',
      'RFC-NoPockets-SafetyYellow_1.webp',
      'Sarah-NoPockets-SafetyYellow_11.webp',
      'TitusH-NoPockets-HotPink_7.webp',
      'YasminF-NoPockets-HotPink_9.webp',
      'YasminF-NoPockets-HotPink_10.webp'
    ],
    'pockets-legacy': [
      'vest_pockets_infinite_gallery_1.webp?v=1754773768',
      'vest_pockets_infinite_gallery_2.webp?v=1754773768',
      'vest_pockets_infinite_gallery_3.webp?v=1754773768',
      'vest_pockets_infinite_gallery_4.webp?v=1754773768',
      'vest_pockets_infinite_gallery_9.webp?v=1754773768',
      'vest_pockets_infinite_gallery_5.webp?v=1754773768',
      'vest_pockets_infinite_gallery_6.webp?v=1754773768',
      'vest_pockets_infinite_gallery_7.webp?v=1754773768',
      'vest_pockets_infinite_gallery_8.webp?v=1754773768',
      'vest_pockets_infinite_gallery_10.webp?v=1754773768',
      'vest_pockets_infinite_gallery_14.webp?v=1754773768',
      'vest_pockets_infinite_gallery_15.webp?v=1754773768',
      'vest_pockets_infinite_gallery_17.webp?v=1754773768',
      'vest_pockets_infinite_gallery_11.webp?v=1754773768',
      'vest_pockets_infinite_gallery_12.webp?v=1754773768',
      'vest_pockets_infinite_gallery_21.webp?v=1754773768',
      'vest_pockets_infinite_gallery_22.webp?v=1754773768',
      'vest_pockets_infinite_gallery_24.webp?v=1754773768'
    ],
    'named-legacy': [
      'infinite_gallery_-_Tatiana_Samuel.webp?v=1741311307',
      'infinite_gallery_-_sam.webp?v=1741311307',
      'infinite_gallery_-_Noelle_Nanda_s_Mom.webp?v=1741311302',
      'infinite_gallery_-_maxduckworth.webp?v=1741311307',
      'infinite_gallery_-_keren_temelie_1.webp?v=1741311307',
      'infinite_gallery_-_Josie_Doefer.webp?v=1741311307',
      'infinite_gallery_-_joanne.webp?v=1741311307',
      'infinite_gallery_-_ashley_runkle.webp?v=1741311307',
      'infinite_gallery_-_Sam_in_the_subway.webp?v=1741311307',
      'infinite_gallery_-_Jackie_Sorensen.webp?v=1741311307',
      'infinite_gallery_-_iammeganmarie.webp?v=1741311307',
      'infinite_gallery_-_hugging_tuesday.webp?v=1741311307',
      'infinite_gallery_-_helenaburkett3.webp?v=1741311307',
      'infinite_gallery_-_elizabeth_4.webp?v=1741311307',
      'infinite_gallery_-_rebecca_h.webp?v=1741311307',
      'infinite_gallery_-_cargobikemomma_3.webp?v=1741311307',
      'infinite_gallery_-_bunchbikes.webp?v=1741311307',
      'infinite_gallery_-_Craig.webp?v=1747178131',
      'infinite_gallery_-_ashley_runkle2.webp?v=1741311307',
      'infinite_gallery_-_ana1.webp?v=1741311307'
    ]
  };

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function shuffle(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function poolFor(mode) {
    if (mode === 'pockets') return POOLS.pockets;
    if (mode === 'nopockets') return POOLS.nopockets;
    if (mode === 'pockets-legacy') return POOLS['pockets-legacy'];
    if (mode === 'named-legacy') return POOLS['named-legacy'];
    return POOLS.pockets.concat(POOLS.nopockets);
  }

  function fileUrl(file, width) {
    var url = file.indexOf('http') === 0 ? file : CDN + file;
    var join = url.indexOf('?') === -1 ? '?' : '&';
    return url + join + 'width=' + (width || 400);
  }

  function srcset(file) {
    var base = file.indexOf('http') === 0 ? file : CDN + file;
    var join = base.indexOf('?') === -1 ? '?' : '&';
    return (
      base + join + 'width=400 400w, ' +
      base + join + 'width=800 800w'
    );
  }

  function altText(file) {
    var name = file.split('/').pop().split('?')[0];
    var match = name.match(/-(Pockets|NoPockets)-([A-Za-z]+)_\d+\.webp/i);
    if (match) {
      var type = match[1] === 'Pockets' ? ' with pockets' : '';
      var color = match[2].replace(/([a-z])([A-Z])/g, '$1 $2');
      return 'Customer wearing ' + color + ' Lace Safety Vest' + type;
    }
    return 'Customer wearing Lace Safety Vest';
  }

  function createImage(file, cloned) {
    var img = document.createElement('img');
    img.src = fileUrl(file, 400);
    img.srcset = srcset(file);
    img.sizes = '(max-width: 480px) 169px, (max-width: 768px) 197px, 225px';
    img.width = 225;
    img.height = 400;
    img.alt = cloned ? '' : altText(file);
    img.decoding = 'async';
    img.loading = 'lazy';
    img.draggable = false;
    img.setAttribute('fetchpriority', 'low');
    return img;
  }

  function LsvCustomerGallery(root) {
    this.root = root;
    this.track = root.querySelector('.lsv-customer-gallery__track');
    this.mode = root.getAttribute('data-mode') || 'all';
    this.direction = root.getAttribute('data-direction') || 'rtl';
    this.count = parseInt(root.getAttribute('data-count'), 10) || 18;
    this.inView = false;
    this.started = false;
    this.observer = null;
    this.init();
  }

  LsvCustomerGallery.prototype.init = function () {
    var pool = poolFor(this.mode);
    var files = this.mode.indexOf('legacy') !== -1 ? pool.slice(0, this.count) : shuffle(pool).slice(0, Math.min(this.count, pool.length));
    var group = document.createElement('div');
    var clone = document.createElement('div');
    group.className = 'lsv-customer-gallery__group';
    clone.className = 'lsv-customer-gallery__group';
    clone.setAttribute('aria-hidden', 'true');

    files.forEach(function (file) {
      group.appendChild(createImage(file, false));
    });

    this.track.replaceChildren(group);
    this.root.setAttribute('data-direction', this.direction);
    this.setDuration();
    this.bind();

    var self = this;
    window.setTimeout(function () {
      if (!prefersReducedMotion()) {
        files.forEach(function (file) {
          clone.appendChild(createImage(file, true));
        });
        self.track.appendChild(clone);
      }
      self.started = true;
      self.syncPlayback();
    }, START_DELAY);
  };

  LsvCustomerGallery.prototype.setDuration = function () {
    var group = this.track.querySelector('.lsv-customer-gallery__group');
    var width = group ? group.scrollWidth : this.count * 225;
    var duration = Math.max(width / PX_PER_SECOND, 40);
    this.root.style.setProperty('--lsv-gallery-duration', duration.toFixed(1) + 's');
  };

  LsvCustomerGallery.prototype.syncPlayback = function () {
    var play = this.started && this.inView && document.visibilityState !== 'hidden' && !prefersReducedMotion();
    this.root.classList.toggle('is-playing', play);
  };

  LsvCustomerGallery.prototype.bind = function () {
    var self = this;
    this.observer = new IntersectionObserver(
      function (entries) {
        self.inView = entries.some(function (entry) { return entry.isIntersecting; });
        self.syncPlayback();
      },
      { rootMargin: '100px 0px', threshold: 0.01 }
    );
    this.observer.observe(this.root);
    document.addEventListener('visibilitychange', this);
    window.addEventListener('resize', this);
    if (window.matchMedia) {
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motionQuery.addEventListener) this.motionQuery.addEventListener('change', this);
      else if (this.motionQuery.addListener) this.motionQuery.addListener(this);
    }
  };

  LsvCustomerGallery.prototype.handleEvent = function (event) {
    var self = this;
    if (event.type === 'visibilitychange' || event.type === 'change') this.syncPlayback();
    if (event.type === 'resize') {
      if (this.resizeTick) return;
      this.resizeTick = true;
      window.requestAnimationFrame(function () {
        self.resizeTick = false;
        self.setDuration();
      });
    }
  };

  LsvCustomerGallery.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('visibilitychange', this);
    window.removeEventListener('resize', this);
    if (this.motionQuery) {
      if (this.motionQuery.removeEventListener) this.motionQuery.removeEventListener('change', this);
      else if (this.motionQuery.removeListener) this.motionQuery.removeListener(this);
    }
    this.root.classList.remove('is-playing');
    delete this.root._lsvGallery;
  };

  function boot() {
    document.querySelectorAll('[data-lsv-customer-gallery]').forEach(function (root) {
      if (root._lsvGallery) return;
      root._lsvGallery = new LsvCustomerGallery(root);
    });
  }

  function onSectionUnload(event) {
    var root = event.target && event.target.querySelector('[data-lsv-customer-gallery]');
    if (root && root._lsvGallery) root._lsvGallery.destroy();
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  if (document.readyState !== 'loading') boot();
})();
